module.exports = __webpack_public_path__ + "4fb48779267c528fcc58f98b6bd25ea1.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lankenau05.jpg
// module id = 661
// module chunks = 0